import { render, staticRenderFns } from "./it-index.vue?vue&type=template&id=61dc8121&scoped=true"
import script from "./it-index.vue?vue&type=script&lang=js"
export * from "./it-index.vue?vue&type=script&lang=js"
import style0 from "./it-index.vue?vue&type=style&index=0&id=61dc8121&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc8121",
  null
  
)

export default component.exports